<footer *ngIf="showFooter" class="bg-dark text-light pt-sm-5">
    <div class="container py-5">
        <div class="row">
            <div class="col-sm-6 col-md-4">
                <img class="logo-footer mb-3" src="/assets/images/home/footer-logo.svg" />

                <div class="company-info">Registered Name: The Upps (Pty) Ltd</div>
                <div class="company-info">Registration Number: 2022/433971/07</div>
                <div class="company-info">VAT number: 4620313298</div>
                <!--                                    <div class="company-info">Date of Registration: 01-07-2023</div>-->
                <div class="company-info">32 Kloof St, Gardens, Cape Town, 8001, South Africa</div>
                <br />
                <div class="d-none d-md-block">
                    <img class="payment-image-lg" src="/assets/images/footer/payment-logos.png" />
                </div>
            </div>
            <div class="col-12 col-md-4">
                <h6>Get In Touch</h6>
                <div>
                    <b>General Enquiries:</b>
                    <br />
                    <a class="" href="mailto:info@parkupp.co.za">info&#64;parkupp.co.za</a>
                    <br />
                    <br />
                </div>
                <div>
                    <b>Gauteng Enquiries</b>
                    <br />
                    E: <a class="" href="mailto:lesedi@parkupp.co.za">lesedi&#64;parkupp.co.za</a>
                    <br />
                    T: <a class="" href="tel:+27 63 596 0446">063 596 0446</a>
                    <br />
                    <br />
                </div>
                <div>
                    <b>Cape Town and Durban Enquiries</b><br />
                    E: <a class="" href="mailto:umar@parkupp.co.za">umar&#64;parkupp.co.za</a>
                    <br />
                    T: <a class="" href="tel:+27 71 280 2308">071 280 2308</a>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 my-5 my-md-0">
                <h6>Links:</h6>
                <a [routerLink]="['/about-us']">About Us</a><br />
                <a [routerLink]="['/how-it-works']">How it Works</a><br />
                <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a><br />
                <a [routerLink]="['/privacy']">Privacy Policy</a><br />
                <a [routerLink]="['/data-deletion']">Data Deletion Policy</a><br />
                <br />
                <h6>Social media:</h6>
                <a class="d-inline-block fs-3" href="https://www.facebook.com/parkupp.co.za" target="_blank"> <i class="fab fa-facebook"></i> </a>&nbsp;
                <a class="d-inline-block fs-3" href="https://www.instagram.com/parkupp.co.za/" target="_blank">
                    <i class="fab fa-instagram"></i>
                </a>
                <a class="d-inline-block fs-3 mx-2" href="https://za.linkedin.com/company/parkuppza" target="_blank">
                    <i class="fab fa-linkedin"></i>
                </a>
                <br />
                <br />
                <div class="d-block d-sm-none">
                    <img class="payment-image-lg" src="/assets/images/footer/payment-logos.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="own-risk col-12 text-center text-sm mb-2">PARKING AT YOUR OWN RISK</div>
            <div class="col-12 text-center text-sm">All rights reserved ©</div>
        </div>
    </div>
    <div class="container py-4"></div>
</footer>
